import { relayQueryKey } from 'queries/relay/queryKey';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';
import { RelayRollingApi } from 'api/ApiHelper';

export const useGetRelayRollingQuery = (rollingId: number, includeAdult: boolean) =>
  useQuery({
    queryKey: relayQueryKey.rollingById(rollingId, includeAdult),
    queryFn: () => RelayRollingApi.findByRollingId(rollingId, includeAdult),
  });

export const prefetchRelayRollingQuery = async (
  queryClient: QueryClient,
  options: AxiosRequestConfig,
  rollingId: number,
  includeAdult: boolean,
) =>
  queryClient.prefetchQuery({
    queryKey: relayQueryKey.rollingById(rollingId, includeAdult),
    queryFn: () => RelayRollingApi.findByRollingId(rollingId, includeAdult, options),
  });
